import { URL as API_BASE } from '../../variables';
export async function organizationRequest(
  token,
  path = 'minha-organizadora',
  method = 'GET',
  data
) {
  const form = data instanceof FormData,
    response = await fetch(`${API_BASE}api/${path}`, {
      method,
      headers: {
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
        ...(data && !form ? { 'Content-Type': 'application/json' } : {}),
      },
      body: data ? (form ? data : JSON.stringify(data)) : undefined,
    });
  const json = await response.json().catch(() => null);
  if (!response.ok) {
    const e = new Error(json?.message || 'Não foi possível concluir a operação.');
    e.fields = json?.errors || {};
    throw e;
  }
  return json;
}
